import { TableOptions, TableVisibility, DatatableInterface } from '@/components/data-table/DataTable';
import { PurchaseOrder, PurchaseOrderFilterFlatInterface, PurchaseOrderFilterFlatInterfaceKeyType, PurchaseOrderFilterInterface, PurchaseOrderTableHeader } from '@/models/PurchaseOrder';
import { Component } from 'vue-property-decorator';
import AbstractDatatable from '@/components/CustomDatatable/AbstractDatatable';

@Component<PurchaseOrderDatatable>({})
export default class PurchaseOrderDatatable extends AbstractDatatable implements DatatableInterface {

  // #region @Props
  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected defaultPage = 1;

  protected filters: PurchaseOrderFilterFlatInterface = {}; // Keep this object empty

  protected filtersDefault: PurchaseOrderFilterFlatInterface = {}; // Decorate this object if you want to override the defaults inside PurchaseOrderFilters

  protected isShowingCreatePurchaseOrderDialog = false;

  protected isLoadingFilters = false;

  protected isShowingFilters = false;

  protected selectedPurchaseOrders: PurchaseOrder[] = [];

  protected tableVisibility: TableVisibility = {
    checkboxes: false,
    limit: true,
    pagination: true,
  };

  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers

  public onFiltersChanged(): void {
    // Do not reset the page on reload
    if (! this.isLoadingFilters) {
      this.page = 1;
    }
  }

  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters

  protected get page() {
    const result = localStorage.getItem(`${this.$route.name}_page`);
    return result ? Number(result) : this.defaultPage;
  }

  protected set page(page: number) {
    localStorage.setItem(`${this.$route.name}_page`, page.toString());
    this.defaultPage = page;
  }

  protected get normalizeFilters(): PurchaseOrderFilterInterface {
    const filters: PurchaseOrderFilterInterface = {};

    (Object.entries(this.filters) as [PurchaseOrderFilterFlatInterfaceKeyType, any][]).map((entry) => {
      const [key, value] = entry;

      (filters as any)[key] = value;
    })

    return filters;
  }

  protected get tableOptions(): TableOptions {
    return {
      model: new PurchaseOrder()
        .include(['brand', 'note', 'supplier'])
        .filter(this.normalizeFilters),
      name: {
        singular: 'Purchase order',
        plural: 'Purchase orders'
      },
      sort: {
        key: 'created_at',
        order: 'DESC'
      },
      headers: [
        PurchaseOrderTableHeader.name,
        PurchaseOrderTableHeader.supplier,
        PurchaseOrderTableHeader.brand,
        PurchaseOrderTableHeader.supplier_reference,
        PurchaseOrderTableHeader.status,
        PurchaseOrderTableHeader.master_data_status,
        PurchaseOrderTableHeader.created_at,
        PurchaseOrderTableHeader.quantity,
        PurchaseOrderTableHeader.last_delivery_at,
        PurchaseOrderTableHeader.note,
      ],
      actions: [
        {
          type: 'view',
          label: 'view',
          icon: 'remove_red_eye',
          action: '/purchase-orders/{id}',
          tooltip: 'Show purchase order'
        }
      ],
      filters: [],
    }
  }

  // #endregion

  // #endregion

  // #region @Watchers
  // #endregion
}
